(function(){
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* reveal on scroll */
  var targets = document.querySelectorAll(
    '.ls-intro .lede, .ls-intro .promise, .ls-count, .ls-h, .reason, .ls-mini, .cta, .guarantee, .reviews h2, .reviews .sub, .r-card'
  );
  targets.forEach(function(el){ el.classList.add('reveal'); });
  if(reduce || !('IntersectionObserver' in window)){
    targets.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.06});
    targets.forEach(function(el){ io.observe(el); });
  }

  /* top promo bar: appears once the user starts scrolling */
  var top = document.getElementById('plxTop');
  if(top){
    var onScroll = function(){ top.classList.toggle('show', (window.pageYOffset||document.documentElement.scrollTop) > 60); };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* bottom sticky CTA: show after the hero scrolls away, hide over the footer / final CTA */
  var bot = document.getElementById('plxBot');
  if(bot){
    var pastHero = false, atEnd = false;
    function sync(){ bot.classList.toggle('show', pastHero && !atEnd); }

    if('IntersectionObserver' in window){
      var mast = document.querySelector('.masthead');
      if(mast){
        new IntersectionObserver(function(en){
          pastHero = !en[0].isIntersecting; sync();
        }, {rootMargin:'-40px 0px 0px 0px'}).observe(mast);
      } else { pastHero = true; }

      /* hide once the footer or the reviews CTA comes into view (avoid stacking CTAs) */
      var end = document.querySelector('footer') || document.querySelector('.reviews');
      if(end){
        new IntersectionObserver(function(en){
          atEnd = en[0].isIntersecting; sync();
        }, {rootMargin:'0px 0px -10% 0px'}).observe(end);
      }
    } else {
      bot.classList.add('show');
    }
  }
})();
